export default {
  namespaced: true,
  state: {
    formModified: false,
  },

  getters: {
    formModified: (state) => state.formModified,
  },

  mutations: {
    modified(state, modified) {
      state.formModified = modified
    },
  },
}
